var style = {"field":"Field-module_field__auVUL","name":"Field-module_name__gUwz2","required":"Field-module_required__DDXjt"};

export { style as default };
//# sourceMappingURL=Field.module.scss.js.map
